{
	"content": {
		"title": "Seleccione los materiales que requieren declaraciones",
		"materialListLabel": "Material",
		"materialQuantityLabel": "Cantidad de material ({{unit}})",
		"availableQuantityLabel": "Cantidad disponible ({{unit}})",
		"carbonSavingsLabel": "Reducciones de carbono ({{unit}} CO₂ eq.)"
	},
	"summary": {
		"title": "Resumen",
		"declarationTypeTitle": "Tipo de declaración",
		"customerProjectTitle": "Proyecto de cliente",
		"internalProjectOrProductTitle": "Proyecto/producto interno",
		"projectReferenceTitle": "Referencia del proyecto",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantidad ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Reducciones de carbono asignables ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Reducción de carbono no asignable ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Se requiere cantidad",
		"quantityPositive": "Por favor ingrese una cantidad positiva.",
		"quantityLargerThanAvailable": "Por favor reduzca la cantidad al total disponible.",
		"savingsRequired": "Se requieren reducciones de carbono",
		"fetchNotTransferedMaterialsError": "No se pudieron recuperar los materiales no transferidos"
	},
	"submitTitle": "Añadir al proyecto",
	"backTitle": "Atrás"
}
